export enum PermissionsAPI {
    UPLOAD_PUBLIC_FILES = 'UPLOAD_PUBLIC_FILES',
    UPLOAD_PRIVATE_FILES = 'UPLOAD_PRIVATE_FILES',
    DOWNLOAD_PRIVATE_FILES = 'DOWNLOAD_PRIVATE_FILES',
    DELETE_FILES = 'DELETE_FILES',
    DELETE_EXPIRED_FILES = 'DELETE_EXPIRED_FILES'
}

export function checkPermission(permission: PermissionsAPI): boolean {
    return !!window.Live.authorization.permissions[permission]
}

export interface PermissionsContextModel {
    uploadPrivateFile: boolean
    uploadPublicFile: boolean
    downloadPrivateFiles: boolean
    deletePrivateFiles: boolean
    deleteFiles: boolean
}

export function checkAllPermission(): PermissionsContextModel {
    return {
        uploadPrivateFile: checkPermission(PermissionsAPI.UPLOAD_PRIVATE_FILES),
        uploadPublicFile: checkPermission(PermissionsAPI.UPLOAD_PUBLIC_FILES),
        downloadPrivateFiles: checkPermission(PermissionsAPI.DOWNLOAD_PRIVATE_FILES),
        deletePrivateFiles: checkPermission(PermissionsAPI.DELETE_EXPIRED_FILES),
        deleteFiles: checkPermission(PermissionsAPI.DELETE_FILES)
    }
}

export function getDefaultPropIsPublic(permission: PermissionsContextModel): boolean {
    if (permission.uploadPrivateFile && permission.uploadPublicFile) {
        return false
    }
    if (permission.uploadPrivateFile) {
        return false
    }
    return true
}
